import React from "react";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import Illustration from "apps/website/components/base/Illustration/Illustration";

import { ISpotlightOption } from "../RadioButtons.types";

const SpotlightOption = React.forwardRef<HTMLDivElement, ISpotlightOption>((props, ref) => (
  <div
    data-component={props.component ?? SpotlightOption.name}
    data-value={props.value}
    aria-disabled={props.disabled || undefined}
    className="spotlight-option flex flex-col items-center justify-center"
    ref={ref}
  >
    <div className="relative flex items-center justify-center">
      { props.selected && (
        <div data-testid="spotlight-circle" className="absolute z-0 rounded-full bg-brand w-[3.75rem] h-[3.75rem]" />
      ) }
      <Illustration illustration={props.illustration} size="mediumLarge" className="z-10" />
    </div>
    <TextSubtitle
      size={3}
      align={"center"}
    >
      { props.label }
    </TextSubtitle>
  </div>
));

SpotlightOption.displayName = "SpotlightOptionComponent";

export default SpotlightOption;
